import store from '@/store/Index.js';

export default async (to, from, next) => {
    if (!store.getters['Auth/check']) {
        next({ name: 'home' });
    } else {
        next();
    }
};
